module.exports = __webpack_public_path__ + "img/reviews-author-12@2x.ace59a1.jpg";